module.exports = __webpack_public_path__ + "img/smoo.c6bda3ec.png";